/* ════════════════════════════════════════════════════════════════════════
   KILIM — COMPORTEMENTS DE LA FICHE PRODUIT
   Porté de design/pdp-seo/fiche.html. Chargé en `defer` par
   sections/pdp-fiche.liquid.

   Ce script n'est qu'une amélioration. Sans lui la page reste utilisable :
   le nuancier est fait de formulaires GET qui naviguent vers `?variant=`,
   la quantité est un `<input type="number">`, et l'ajout au panier est un
   submit. Rien ici n'est nécessaire pour acheter.

   Trois blocs de la maquette ne sont PAS portés — le nom du coloris, la
   quantité simulée et l'ajout au panier simulé : ils sont désormais rendus
   par le serveur. La maquette en contenait aussi des copies dupliquées.
   ════════════════════════════════════════════════════════════════════════ */

/* Galerie — une seule mécanique pour deux comportements.

   Le rail est la source de vérité de la prise active. En tactile il défile
   horizontalement et le doigt écrit dedans ; à partir de 900 px il n'est
   plus un rail mais une colonne, et c'est le défilement de la page qui
   écrit. Dans les deux cas la question est la même — quelle prise occupe la
   vue — et un seul IntersectionObserver y répond.

   Observer plutôt qu'un écouteur de défilement : il ne se déclenche qu'au
   franchissement, là où un écouteur recalcule la même valeur à chaque frame
   et fait tomber l'INP. */
(function () {
  var rail = document.getElementById('rail');
  var surcouche = document.getElementById('vignettes');
  /* Une fiche a une seule photographie ne rend ni vignettes ni compteur. */
  if (!rail || !surcouche) return;
  var vues = Array.prototype.slice.call(rail.children);
  var vign = Array.prototype.slice.call(surcouche.children);
  var courant = document.getElementById('courant');
  var empile = window.matchMedia('(min-width: 900px)');

  /* PRISES SUIVANTES CHARGEES D'AVANCE (06/10/2026). Une image blanche est
     apparue pendant un glissement. Verifie : ce n'est pas le poids (de 68 a
     95 Ko en WebP a 1024 px, mesure le 06/10), c'est le `loading="lazy"`.
     Dans un rail horizontal, Safari n'appelle l'image qu'une fois sa prise
     presque a l'ecran : un glissement rapide arrive avant elle. La premiere
     prise reste seule prioritaire (LCP) ; les suivantes partent des que la
     page a fini de charger, ou au premier contact du doigt si c'est plus tot. */
  function precharger() {
    Array.prototype.forEach.call(rail.querySelectorAll('img[loading="lazy"]'),
      function (im) { im.loading = 'eager'; });
  }
  if (document.readyState === 'complete') precharger();
  else addEventListener('load', precharger, { once: true });
  rail.addEventListener('touchstart', precharger, { once: true, passive: true });

  function marquer(i) {
    vign.forEach(function (b, n) { b.setAttribute('aria-current', String(n === i)); });
    courant.textContent = i + 1;
  }

  /* Racine différente selon le mode : le rail lui-même quand il défile
     horizontalement, la fenêtre quand les prises sont empilées. */
  var obs;
  function observer() {
    if (obs) obs.disconnect();
    obs = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        if (e.isIntersecting) marquer(vues.indexOf(e.target));
      });
    }, empile.matches ? { threshold: 0.5 }
                      : { root: rail, threshold: 0.6 });
    vues.forEach(function (v) { obs.observe(v); });
  }
  observer();
  empile.addEventListener('change', observer);

  vign.forEach(function (b, i) {
    b.addEventListener('click', function () {
      if (empile.matches) {
        /* Empilé : on amène la prise sous l'en-tête. 'instant' et non
           'smooth' — §11 impose la coupe franche entre deux prises, « une
           coupe est plus honnête qu'un fondu quand il s'agit de comparer
           deux états d'une couleur ». */
        var haut = vues[i].getBoundingClientRect().top + window.scrollY - 76 - 24;
        window.scrollTo({ top: haut, behavior: 'instant' });
      } else {
        rail.scrollTo({ left: vues[i].offsetLeft - vues[0].offsetLeft, behavior: 'instant' });
      }
      marquer(i);
    });
  });
})();

/* Onglets de maillage — le panneau suit le titre sélectionné.
   Aucune animation : c'est une action de navigation, répétée, et §11 pose
   que fréquence et animation sont inversement proportionnelles. */
(function () {
  var onglets = Array.prototype.slice.call(
    document.querySelectorAll('.reco__onglets button'));
  if (!onglets.length) return;
  onglets.forEach(function (b) {
    b.addEventListener('click', function () {
      onglets.forEach(function (x) {
        var actif = x === b;
        x.setAttribute('aria-selected', String(actif));
        document.getElementById(x.getAttribute('aria-controls')).hidden = !actif;
      });
    });
  });
})();

/* En-tête tactile — transparente au-dessus de l'image, pleine dès qu'on la
   quitte (§9.3). La bascule s'observe sur la galerie elle-même et non sur
   une sentinelle de 1 px : un défilement rapide franchit une sentinelle
   entre deux frames, l'observateur la voit hors champ avant et après, et
   aucun changement d'état n'est déclenché.

   Le décalage négatif vaut la hauteur de l'en-tête : l'état bascule quand le
   bas de l'image atteint le bas de la barre, pas quand il quitte l'écran. */
(function () {
  var entete = document.querySelector('.entete');
  var galerie = document.querySelector('.galerie');
  var img = document.querySelector('#rail > figure img');
  var K80 = [0x2F, 0x24, 0x1B], K00 = [0xF9, 0xF7, 0xF3];

  /* CE SCRIPT N'ECRIT PLUS `data-etat`. CORRIGE LE 20/09/2026.

     Il le faisait, et c'etait la cause du tremblement signale au defilement :
     `flottante` et `pleine` ne changent pas seulement une couleur, ils
     changent LE FLUX DU DOCUMENT. En flottante la barre se superpose au
     contenu, en pleine elle occupe sa place. Basculer de l'un a l'autre
     pendant le defilement deplacait `<main>` de 76 px — la hauteur de
     l'en-tete — a chaque fois que la barre passait d'une zone lisible a une
     zone qui ne l'est pas. Mesure : un decalage de 0,0528 a chaque bascule.

     La regle : l'etat de flux est decide UNE FOIS, au rendu, par
     sections/entete.liquid. Ce script ne touche plus qu'a la couleur.

     Quand aucune des deux couleurs ne tient le contraste, on garde la
     variante claire : le voile clair de DESIGN.md §8.3 la rattrape, et un
     voile coute un repaint la ou un changement de flux coute un reflow et un
     saut visible. */
  var surImage = true;     // la galerie occupe encore le haut de l'écran
  var lisible = null;      // 'clair', 'sombre', ou false si aucune ne tient

  function appliquer() {
    if (!surImage) { entete.removeAttribute('data-fond'); return; }
    entete.dataset.fond = lisible || 'clair';
  }

  function lum(c) {
    var s = c.map(function (v) { v /= 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); });
    return 0.2126 * s[0] + 0.7152 * s[1] + 0.0722 * s[2];
  }
  function ratio(a, b) {
    var l1 = lum(a), l2 = lum(b);
    return (Math.max(l1, l2) + 0.05) / (Math.min(l1, l2) + 0.05);
  }

  /* Lisibilité de la barre sur l'image — mesurée, jamais devinée.
     §9.3 laisse deux variantes : texte sombre sur image claire, texte clair
     sur image sombre. Laquelle s'applique dépend de la photographie, qui
     change à chaque produit. On échantillonne donc les pixels réellement
     couverts par les libellés, on calcule le contraste que donnerait chacune
     des deux valeurs, et on retient la meilleure. Si aucune n'atteint
     4,5:1 — image mi-claire mi-sombre sous la barre —, la transparence est
     abandonnée. §6.1 : entre l'accessibilité et l'esthétique, c'est
     l'esthétique qui saute. Ce cas se corrige à la prise de vue. */
  function mesurer() {
    var r = img.getBoundingClientRect();
    if (r.height <= 0 || !img.naturalWidth) return;
    var W = innerWidth, H = entete.offsetHeight || 76;
    var cv = document.createElement('canvas');
    cv.width = W; cv.height = H;
    var cx = cv.getContext('2d', { willReadFrequently: true });
    try {
      /* Reproduire `object-fit: cover`, sinon on mesure le fichier source et
         non ce qui est affiché. Sur ce pilote l'écart n'est pas un détail :
         1003 × 1568 dans un cadre de 720 × 960, le cover rogne 116 px en
         haut, et lire le fichier brut donnait le mur clair là où l'écran
         montre le hijab — 6,02:1 annoncé pour un vrai contraste sous le
         seuil. */
      var e = Math.max(r.width / img.naturalWidth, r.height / img.naturalHeight);
      var sw = r.width / e;
      var sx = (img.naturalWidth - sw) / 2;
      var sy = (img.naturalHeight - r.height / e) / 2 + (0 - r.top) / e;
      cx.drawImage(img, sx, sy, sw, H / e, r.left, 0, r.width, H);

      var d = cx.getImageData(0, 0, W, H).data;
      var pireSombre = 99, pireClair = 99, vu = false;
      /* UNE COULEUR PAR LIBELLE (06/10/2026). Sur bureau la galerie ne
         couvre que la moitie gauche : les familles sont sur la photo, la
         marque a cheval, Contact et Panier sur le fond creme. Une seule
         couleur pour toute la barre effacait toujours une moitie : texte
         sombre, les familles disparaissaient dans une photo sombre ; texte
         clair, la marque et le panier disparaissaient sur le creme. Chaque
         libelle recoit donc sa couleur (`data-ton`), mesuree sur ses
         propres pixels, le creme compte pour ce qu'il est. */
      Array.prototype.forEach.call(
        entete.querySelectorAll('.entete__famille > a, .service a, .marque, .entete__burger'), function (el) {
          var z = el.getBoundingClientRect();
          var ps = 99, pc = 99;
          for (var y = Math.max(0, z.top | 0); y < Math.min(H, z.bottom | 0); y += 3)
            for (var x = Math.max(0, z.left | 0); x < Math.min(W, z.right); x += 3) {
              var i = (y * W + x) * 4;
              var px = d[i + 3] === 0 ? K00 : [d[i], d[i + 1], d[i + 2]];
              ps = Math.min(ps, ratio(px, K80));
              pc = Math.min(pc, ratio(px, K00));
              if (d[i + 3] === 0) continue;   // hors image : le champ clair
              vu = true;
              pireSombre = Math.min(pireSombre, ratio(px, K80));
              pireClair  = Math.min(pireClair,  ratio(px, K00));
            }
          if (ps === 99) el.removeAttribute('data-ton');
          else el.dataset.ton = ps >= pc ? 'clair' : 'sombre';
        });

      if (!vu) lisible = 'clair';
      else if (Math.max(pireSombre, pireClair) < 4.5) lisible = false;
      else lisible = pireClair > pireSombre ? 'sombre' : 'clair';
    } catch (err) {
      /* Image d'un autre domaine sans en-tête CORS : le canvas est souillé.
         On ne devine pas — barre pleine. En production, servir les images
         avec crossorigin. */
      lisible = false;
    }
    appliquer();
  }

  /* La bascule s'observe sur la galerie et non sur une sentinelle de 1 px :
     un défilement rapide franchit une sentinelle entre deux frames et aucun
     changement d'état n'est déclenché. Le décalage négatif vaut la hauteur
     de la barre — l'état change quand le bas de l'image atteint le bas de
     la barre, pas quand il quitte l'écran. */
  new IntersectionObserver(function (entrees) {
    entrees.forEach(function (e) { surImage = e.isIntersecting; appliquer(); });
  }, { rootMargin: '-' + (entete.offsetHeight || 76) + 'px 0px 0px 0px', threshold: 0 }).observe(galerie);

  img.complete ? mesurer() : img.addEventListener('load', mesurer);
  addEventListener('resize', mesurer);
})();

/* BLOC RETIRE AU PORTAGE, 20/09/2026 — barre d'action collante.

   Le script de la maquette observait `.prix` pour faire entrer une barre
   d'achat `#barre` quand le prix sort du champ. Cette barre n'existe DANS
   AUCUNE maquette : ni fiche.html, ni les quatre PDP locales. Seul le jeton
   `--barre-h: 120px` en porte la trace.

   Consequence en production : `document.getElementById('barre')` renvoyait
   null et l'observateur levait une TypeError A CHAQUE franchissement, ce qui
   interrompait le reste du script — notamment la retraction de l'en-tete.

   On ne recree pas ici une barre qui n'a jamais ete dessinee. A trancher
   dans DESIGN.md avant de la construire. */

/* ── La quantité ───────────────────────────────────────────────────────
   Les deux boutons pilotent un vrai <input type="number"> : sans script il
   reste saisissable au clavier, et le formulaire part avec la bonne valeur.
   `stepUp`/`stepDown` respectent min et step déclarés dans le balisage, donc
   la règle n'est écrite qu'à un seul endroit. */
(function () {
  var champ = document.getElementById('qte');
  if (!champ) return;

  var moins = document.getElementById('moins');
  var plus = document.getElementById('plus');

  function changer(sens) {
    if (sens > 0) champ.stepUp();
    else champ.stepDown();
    champ.dispatchEvent(new Event('change', { bubbles: true }));
  }

  if (moins) moins.addEventListener('click', function () { changer(-1); });
  if (plus) plus.addEventListener('click', function () { changer(1); });
})();

/* ── Choix du coloris sans rechargement ─────────────────────────────────
   Ajoute le 23/09/2026. Chaque groupe d'options est un formulaire GET vers
   ?variant=<id> : sans JavaScript, la page se recharge et tout reste juste.
   Avec, le clic ne fait que selectionner : la variante du panier, le nom
   affiche, la pastille pressee, le prix et l'adresse changent sur place.
   Aucune image n'est rechargee — c'est la demande : on prend le coloris, et
   c'est tout. */
(function () {
  var donnees = document.getElementById('variantes-json');
  var forme = document.getElementById('form-achat');
  if (!donnees || !forme) return;
  var variantes = JSON.parse(donnees.textContent);
  var groupes = Array.prototype.slice.call(document.querySelectorAll('.achat__groupe'));
  var champ = forme.querySelector('input[name="id"]');
  var prix = document.querySelector('.achat .prix, .prix');
  var bouton = document.getElementById('ajout');

  /* La valeur Shopify complete vit dans data-valeur (« Noir · 01 ») ;
     aria-label ne porte plus que le nom affiche (06/10/2026). */
  function valeur(b) { return b.getAttribute('data-valeur'); }

  function choix() {
    return groupes.map(function (g) {
      var b = g.querySelector('button[aria-pressed="true"]');
      return b ? valeur(b) : null;
    });
  }
  function trouver(sel) {
    return variantes.filter(function (v) {
      return v.o.every(function (x, i) { return sel[i] === null || x === sel[i]; });
    })[0];
  }

  function appliquer(sel) {
    var v = trouver(sel);
    if (!v) return;
    sel = v.o.slice();
    groupes.forEach(function (g, i) {
      Array.prototype.forEach.call(g.querySelectorAll('button[data-valeur]'), function (b) {
        var val = valeur(b);
        b.setAttribute('aria-pressed', val === sel[i] ? 'true' : 'false');
        var essai = sel.slice(); essai[i] = val;
        var cible = trouver(essai);
        b.disabled = !cible;
        if (cible) b.value = cible.id;
      });
      var nom = g.querySelector('.teintes__nom');
      if (nom) nom.textContent = sel[i].split(' · ')[0];
    });
    if (champ) champ.value = v.id;
    if (prix) {
      prix.textContent = v.p;
      if (v.c) { var s = document.createElement('s'); s.className = 'secondaire'; s.textContent = v.c; prix.appendChild(s); }
    }
    if (bouton) {
      bouton.disabled = !v.a;
      var bp = bouton.querySelector('.btn__prix');
      if (v.a && bp) bp.textContent = v.p;
      else if (v.a) bouton.innerHTML = 'Ajouter au panier <span class="btn__prix nombre">' + v.p + '</span>';
      else bouton.textContent = 'Épuisé';
    }
    var url = new URL(location.href);
    url.searchParams.set('variant', v.id);
    history.replaceState(history.state, '', url);
  }

  groupes.forEach(function (g, i) {
    g.addEventListener('submit', function (e) {
      e.preventDefault();
      var b = e.submitter;
      if (!b || !valeur(b)) return;
      var sel = choix();
      sel[i] = valeur(b);
      appliquer(sel);
    });
  });
})();

/* ── Dates de livraison ─────────────────────────────────────────────────
   « 7 à 14 jours » devient « entre le mar. 30 sept. et le mar. 7 oct. » :
   une date se visualise, un intervalle se calcule. Les bornes viennent des
   reglages de la section (data-min, data-max, data-ouvres) ; rien n'est
   invente ici. Au jour de la visite, cote navigateur (page en cache). */
(function () {
  var ligne = document.querySelector('[data-livraison]');
  if (!ligne) return;
  var min = parseInt(ligne.dataset.min, 10), max = parseInt(ligne.dataset.max, 10);
  if (!(min > 0)) return;
  if (!(max >= min)) max = min;
  var ouvres = ligne.dataset.ouvres === 'true';

  function ajouter(jours) {
    var d = new Date();
    d.setHours(12, 0, 0, 0);
    while (jours > 0) {
      d.setDate(d.getDate() + 1);
      if (ouvres && (d.getDay() === 0 || d.getDay() === 6)) continue;
      jours--;
    }
    return d;
  }
  var fmt = new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' });
  function date(d) {
    var el = document.createElement('strong');
    el.textContent = fmt.format(d);
    return el;
  }

  var texte = ligne.querySelector('[data-livraison-texte]');
  texte.textContent = '';
  if (min === max) {
    texte.append('Livraison estimée le ', date(ajouter(min)));
  } else {
    texte.append('Livraison estimée entre le ', date(ajouter(min)), ' et le ', date(ajouter(max)));
  }
})();
